import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, Subject } from 'rxjs';
import { SearchResult } from 'src/app/models/page-content.model';
import { SearchService } from 'src/app/services/search.service';

@Component({
  selector: 'app-search-modal',
  templateUrl: './search-modal.component.html',
  styleUrls: ['./search-modal.component.scss']
})
export class SearchModalComponent implements OnInit, OnDestroy {
  @Output() closeModal = new EventEmitter<void>();
  
  searchQuery = '';
  searchResults: SearchResult[] = [];
  isSearching = false;
  private searchSubject = new Subject<string>();

  constructor(
    private searchService: SearchService,
    private router: Router,
    private renderer: Renderer2,
    private el: ElementRef,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    // Add modal-open class to body to prevent scrolling
    this.renderer.addClass(document.body, 'modal-open');
    
    // Setup debounce for search
    this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(query => {
      this.performSearch(query);
    });
    
    // Set focus to the search input
    setTimeout(() => {
      const searchInput = this.el.nativeElement.querySelector('.search-input');
      if (searchInput) {
        searchInput.focus();
      }
    }, 100);
  }
  
  ngOnDestroy(): void {
    // Remove modal-open class when component is destroyed
    this.renderer.removeClass(document.body, 'modal-open');
  }

  onSearchInput(event: any): void {
    const query = event.target.value;
    this.searchQuery = query;
    this.searchSubject.next(query);
  }

  onCloseClick(): void {
    this.closeModal.emit();
  }

  navigateToResult(result: SearchResult): void {
    this.closeModal.emit();
    
    // Use the enhanced navigation method from SearchService
    this.searchService.navigateToSearchResult(result);
  }
  
  // Handle escape key to close modal
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Escape') {
      this.onCloseClick();
    }
  }

  stopPropagation(event: Event): void {
    event.stopPropagation();
  }

  private performSearch(query: string): void {
    if (!query || query.trim() === '') {
      this.searchResults = [];
      return;
    }
    
    this.isSearching = true;
    console.log('Searching for:', query);
    
    this.searchService.search(query).subscribe(
      results => {
        console.log('Search results:', results);
        this.searchResults = results;
        this.isSearching = false;
      },
      error => {
        console.error('Search error:', error);
        this.isSearching = false;
      }
    );
  }
}